"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.STAFF_MEMBERS_SCOPES = void 0;
exports.normalizeStaffMembersScope = normalizeStaffMembersScope;
exports.StaffMembersFilterBody = StaffMembersFilterBody;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const FormContext_1 = require("../../View/Modals/FormContext");
const MainSetupReact_1 = __importDefault(require("../../React/MainSetupReact"));
const BussinesObjectSelectors_1 = require("../../View/Modals/CommonFormComponents/BussinesObjectSelectors");
/** Trzy zakresy listy (D-PER-7) w kolejności listy rozwijanej; pierwszy jest domyślny. */
exports.STAFF_MEMBERS_SCOPES = ["permissions", "users", "all"];
/**
 * Nieznana wartość = zakres domyślny - dokładnie tak, jak rozstrzyga serwer. Skąd nieznane
 * wartości: przeglądarka pamięta kryteria filtra, więc po zamianie checkboxa na listę
 * rozwijaną (PER-7) w polu lądowało `false` z dawnego checkboxa, a po „Wyczyść" pusty string.
 * Lista była wtedy już „z uprawnieniami", a pole pokazywało pustkę (uwaga ownera, PER-8).
 */
function normalizeStaffMembersScope(value) {
    return exports.STAFF_MEMBERS_SCOPES.includes(value)
        ? value
        : "permissions";
}
function StaffMembersFilterBody() {
    const { register, watch, setValue } = (0, FormContext_1.useFormContext)();
    const scope = watch("scope");
    // Pole ma pokazywać zakres, którego serwer faktycznie użyje - nigdy pustkę.
    (0, react_1.useEffect)(() => {
        const normalized = normalizeStaffMembersScope(scope);
        if (normalized !== scope)
            setValue("scope", normalized);
    }, [scope, setValue]);
    return (react_1.default.createElement(react_bootstrap_1.Row, { xl: 12, md: 6, xs: 12 },
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, md: 3 },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Szukana fraza"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "text", placeholder: "Imi\u0119, nazwisko lub e-mail", ...register("searchText") })),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, md: 2 },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Rola systemowa"),
            react_1.default.createElement(react_bootstrap_1.Form.Select, { ...register("systemRoleId") },
                react_1.default.createElement("option", { value: "" }, "Wszystkie"),
                Object.entries(MainSetupReact_1.default.SystemRoles).map(([roleName, role]) => (react_1.default.createElement("option", { key: role.id, value: role.id }, roleName))))),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, md: 4 },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Podmiot"),
            react_1.default.createElement(BussinesObjectSelectors_1.EntitySelector, { name: "_entities", multiple: true, showValidationInfo: false })),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { as: react_bootstrap_1.Col, md: 3 },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Zakres"),
            react_1.default.createElement(react_bootstrap_1.Form.Select, { id: "staffScope", ...register("scope") },
                react_1.default.createElement("option", { value: "permissions" }, "Z uprawnieniami"),
                react_1.default.createElement("option", { value: "users" }, "Z kontem"),
                react_1.default.createElement("option", { value: "all" }, "Wszystkie osoby")))));
}
